export const whitelistWebhooks = {
  integrations: {
    'All': false,
    'Webhooks': true,
  },
}

export const blacklistWebhooks = {
  integrations: {
    'Webhooks': false,
  },
}
